import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import {
  PRICE_SCHEDULE_MODES,
  ROUTE_PATHS,
  LEGACY_SCREEN_VIEW,
  NO_CHANGE_OF_INFO
} from "../../common_nextgen/utils/Constants";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import { useModal } from "../../common_nextgen/hooks/ModalContext";
import { formFields } from "./OutOfPocketSubStepConfig";
import useLookupNavigation from "../../common_nextgen/common_components/common-hooks/useLookupNavigation";

const OutOfPocketSubStepForm = ({ mode }) => {
  const location = useLocation();
  const { axios_helper_no_header } = useAxios();
  //const { selectedPriceSchedules = [], previousScreen = '/price-schedule', currentIndex: initialIndex = 0 } = location.state || {};
  const { OUT_OF_POCKET_MAX_SCHEDULE } = ROUTE_PATHS;
  const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);
  const {
    selectedSteps = [],
    previousScreen = OUT_OF_POCKET_MAX_SCHEDULE,
    currentIndex: initialIndex = 0,
    paramsData,
    lookupScreen,
    lookupMode: initialLookupMode,
    navigateData,
    lookupParams,
    formData: baseFormData = {},
    dataDrafted: initialDataDrafted,
    currentMode: initialCurrentMode = mode,
  } = currentState;
  const navigateToPage = useCustomNavigate();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(initialCurrentMode);
  const [initialFormData, setInitialFormData] = useState(baseFormData);
  //const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const [dataDrafted, setDataDrafted] = useState(initialDataDrafted);
  const toast = useToast();

  const screenInfo = {
    ADD: ["Add Out of Pocket Maximum Schedule Substep Detail", "RCOPS003"],
    CHANGE: ["Out of Pocket Maximum Schedule Substep Detail", "RCOPS002"],
    VIEW: ["Out of Pocket Maximum Schedule Substep Detail", "RCOPS002"],
  };

  /*  const { showModal } = useModal();
  const [lookupData, setLookupData] = useState({});
  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
    showModal(lookupScreen, { params }, handleReceiveData, formData);
  };
  const viewLookupDetails = (lookupScreen, params, formData) => {
    const { viewType, fieldMapping } = params;
    const { default: screenNumber } = lookupScreen;
    if (viewType === "legacy") {
      const { default: viewParams } = fieldMapping;
      const paramData = viewParams.reduce((acc, item) => {
        acc[item["legacy"]] = formData[item["source"]];
        return acc;
      }, {});
      const message = {
        message: "navigate-to-presto",
        programCode: LEGACY_SCREEN_VIEW[screenNumber],
        parameters: paramData,
      };
      console.log("message", message);
      window.top?.postMessage(message, "*");
    } else {
      showModal(lookupScreen, { params }, null, formData, true);
    }
  };
*/
  const {
    lookupData,
    fetchLookupData,
    viewLookupDetails,
    lookupMode,
    setLookupMode,
  } = useLookupNavigation({
    initialFormData,
    initialIndex: currentIndex,
    previousState,
    currentState,
    currentMode,
    lookupScreen,
    initialLookupMode,
    navigateData,
    lookupParams,
  });
  const handleBack = () => {
    if (currentIndex < selectedSteps.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setLookupMode(false);
      setCurrentMode(mode);
      setInitialFormData({});
      setDataDrafted(false);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const getPageTitle = useCallback(() => {
    const [screenTitle, screenNumber] = isAddMode(currentMode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>-</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  }, [currentMode]);

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";
    let infoChanged = true;

    if (isAddMode(currentMode)) {
      url = "api/opsOopSchedSubstep/create";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/opsOopSchedSubstep/update";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];

      if (
        JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData) &&
        !dataDrafted
      ) {
           infoChanged = false;
      }
    }

    const data = { ...dataForSubmission, screenNumber, infoChanged };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      if (responseStatus.message === NO_CHANGE_OF_INFO) {
                         toast.current.show({
                           severity: "info",
                           summary: "",
                           detail: responseStatus.message,
                           life: 3000,
                         });
                       } else {
                         toast.current.show({
                           severity: "success",
                           summary: "",
                           detail: responseStatus.message,
                           life: 3000,
                         });
      setInitialFormData(responseData);
      setDataDrafted(false);
      setLookupMode(false);
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      }
    } }catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
      keyName.chmod = "View";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex]);

  useEffect(() => {
    const fetchInitialData = async () => {
      var scheduleName;
      var stepNumber;
      if (isEditMode(currentMode) || isReadOnlyMode(currentMode)) {
        scheduleName =
          currentState.selectedSteps[currentState.currentIndex].opcScheduleName;
        stepNumber =
          currentState.selectedSteps[currentState.currentIndex].opdStepNumber;
      }

      const url = isAddMode(currentMode)
        ? `api/opsOopSchedSubstep/initial-form-data/${encodeURIComponent(
            paramsData.opcScheduleName
          )}?opdStepNumber=${paramsData.opdStepNumber}`
        : `api/opsOopSchedSubstep/${encodeURIComponent(
            scheduleName
          )}?opdStepNumber=${stepNumber}`;

      try {
        const { responseData } = await axios_helper_no_header("GET", url);
        setInitialFormData(responseData);
      } catch (e) {
        console.log(e);
      }
    };

    if (!Object.keys(initialFormData).length) fetchInitialData();
  }, [mode, currentIndex, initialFormData]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          viewLookupDetails={viewLookupDetails}
          lookupData={lookupData}
          fetchLookupData={fetchLookupData}
        />
      </div>
    </div>
  );
};

export default OutOfPocketSubStepForm;
